// extracted by mini-css-extract-plugin
export default {"wishlist_wrapper":"Wishlist_wishlist_wrapper__YH5Ju","cart__empty":"Wishlist_cart__empty__uJk38","wishlist_heading":"Wishlist_wishlist_heading__faM1g"};